import { render, staticRenderFns } from "./CUSelect.vue?vue&type=template&id=c3b323c0&scoped=true"
import script from "./CUSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CUSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CUSelect.vue?vue&type=style&index=0&id=c3b323c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b323c0",
  null
  
)

export default component.exports